<template>
  <div class="base">
    <inside-header color="#fff" title="刘冬冬的课程" />
    <div class="main">
      <van-form input-align="right" @submit="onSubmit">
        <van-field v-model="info.username" name="username" label="姓名" placeholder="姓名/昵称"
          :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field readonly clickable label="性别" :value="info.sex" @click="state.gender = true" />
        <van-popup v-model="state.gender" position="bottom">
          <van-picker show-toolbar :columns="['男', '女']" @confirm="onConfirm" @cancel="state.gender = false" />
        </van-popup>
        <!-- 选择出生日期 -->
        <van-field readonly clickable name="datetimePicker" :value="info.birthday" label="时间选择" placeholder="点击选择时间"
          @click="state.birthdayPicker = true" />
        <van-popup v-model="state.birthdayPicker" position="bottom">
          <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate"
            @confirm="onBirthdayConfirm" @cancel="state.birthdayPicker = false" />
        </van-popup>
        <!-- 学员阶段 -->
        <van-field readonly clickable label="学员阶段" :value="info.stage" @click="state.stage = true" />
        <van-popup v-model="state.stage" position="bottom">
          <van-picker show-toolbar :columns="student_stage" @confirm="onStageConfirm" @cancel="state.stage = false" />
        </van-popup>
        <!-- 提高科目 -->
        <van-field readonly clickable label="提高科目" :value="info.tags" @click="state.tags = true" />
        <van-popup v-model="state.tags" position="bottom">
          <van-tree-select show-toolbar :items="items" :active-id.sync="activeIds"
            :main-active-index.sync="activeIndex" />
        </van-popup>
        <!-- 对教员的要求 -->
        <van-field v-model="info.require_desc" rows="2" autosize label="要求" type="textarea" maxlength="50"
          placeholder="对教员的要求" show-word-limit />
        <div style="margin: 16px;" class="submit-area">
          <a-button class="submit" type="primary">
            提交
          </a-button>
        </div>
      </van-form>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
const items = [
  {
    // 导航名称
    text: '所有科目',
    // 导航名称右上角徽标，2.5.6 版本开始支持
    badge: 3,
    // 是否在导航名称右上角显示小红点
    dot: true,
    // 导航节点额外类名
    className: 'my-class',
    // 该导航下所有的可选项
    children: [
      {
        // 名称
        text: '语文',
        // id，作为匹配选中状态的标识符
        id: 1,
        // 禁用选项
        disabled: true
      },
      {
        text: '数学',
        id: 2
      },
      {
        text: '英语',
        id: 3
      },
      {
        text: '科学',
        id: 4
      },
      {
        text: '化学',
        id: 5
      }
    ]
  }
]

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      state: {
        gender: false,
        birthdayPicker: false,
        stage: false,
        tags: false
      },
      info: {
        sex: '',
        birthday: ''
      },
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2015, 10, 1),
      currentDate: new Date(),
      student_stage: ['小学', '初中一二级', '初三', '高中一二级', '高三'],
      items,
      activeIds: [1, 2],
      activeIndex: 0
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
    onSubmit() {
    },
    onConfirm(value) {
      this.info.sex = value
      this.state.gender = false
    },
    onBirthdayConfirm(time) {
      console.log(time)
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      this.info.birthday = year + '-' + month + '-' + day
      this.state.birthdayPicker = false
    },
    onStageConfirm(stage) {
      this.info.stage = stage
      this.state.stage = false
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .submit-area {
      .submit {
        width: 100%;
        height: 40px;
        background-color: #ff5c00;
        border-radius: 10px;
      }
    }
  }
</style>
